import { EuiSpacer } from '@elastic/eui';
import CardsAvm from 'components/Software/Other_Platforms/AVM_Fritzphone/avmCards';
import YoutubVideo from 'components/Software/Other_Platforms/AVM_Fritzphone/VideoAVMFon';
import NavButtons from 'components/Software/Other_Platforms/NavButtons';
import ForumBox from 'components/Software/Other_Platforms/AVM_Fritzphone/ForumBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  CardsAvm,
  YoutubVideo,
  NavButtons,
  ForumBox,
  BreadCrumbs,
  SEOHelmet,
  React
};